import { type RouteConfig, type RouteConfigComponentProps } from "react-router-config";
import { Redirect } from "react-router-dom";

import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";

import { CartPage } from "@checkout/pages/CartPage";
import { DeliveryPage } from "@checkout/pages/DeliveryPage";
import { OrderSummaryPage } from "@checkout/pages/OrderSummaryPage";
import { Page404 } from "@checkout/pages/Page404";
import { PaymentPage } from "@checkout/pages/PaymentPage";
import { ShippingPage } from "@checkout/pages/ShippingPage";

// TODO: Should be removed DESP-83761
export const LEGACY_routes = [
  {
    path: ["/checkout"],
    exact: true,
    render: () => <Redirect to={standardCheckoutRoutes.shipping} />,
  },
  {
    path: ["/checkout/:orderId", "/trial/checkout/:orderId"],
    exact: true,
    render: ({ match }: RouteConfigComponentProps<{ orderId: string }>) => {
      const { orderId } = match.params;

      return <Redirect to={standardCheckoutRoutes.payment.getBaseUrl(orderId)} />;
    },
  },
  {
    path: [
      "/checkout/:orderId/:paymentToken/pay/successful",
      "/checkout/:orderId/thank-you",
      "/trial/checkout/:orderId/:paymentToken/pay/successful",
    ],
    exact: true,
    render: ({ match }: RouteConfigComponentProps<{ orderId: string; paymentToken: string }>) => {
      const { orderId, paymentToken } = match.params;

      return <Redirect to={standardCheckoutRoutes.payment.getSuccessPaymentUrl(orderId, paymentToken)} />;
    },
  },
  {
    path: ["/checkout/:orderId/payment-failed", "/trial/checkout/:orderId/payment-failed"],
    exact: true,
    render: ({ match }: RouteConfigComponentProps<{ orderId: string }>) => {
      const { orderId } = match.params;

      return <Redirect to={standardCheckoutRoutes.payment.getFailedPaymentUrl(orderId)} />;
    },
  },
];

export const getRoutes = (onNavigate?: (url: string) => void): RouteConfig[] => [
  ...LEGACY_routes,
  {
    path: standardCheckoutRoutes.root,
    exact: true,
    render: () => <CartPage onNavigate={onNavigate} />,
  },
  {
    path: [standardCheckoutRoutes.shipping, trialCheckoutRoutes.shipping],
    exact: true,
    component: ShippingPage,
  },
  {
    path: [standardCheckoutRoutes.delivery, trialCheckoutRoutes.delivery],
    exact: true,
    component: DeliveryPage,
  },
  {
    path: [
      standardCheckoutRoutes.payment.basePath,
      trialCheckoutRoutes.payment.basePath,
      standardCheckoutRoutes.payment.failedPaymentPath,
      trialCheckoutRoutes.payment.failedPaymentPath,
    ],
    exact: true,
    component: PaymentPage,
  },
  {
    path: [
      standardCheckoutRoutes.payment.successPaymentPath,
      trialCheckoutRoutes.payment.successPaymentPath,
      standardCheckoutRoutes.order.summaryPath,
      trialCheckoutRoutes.order.summaryPath,
    ],
    exact: true,
    component: OrderSummaryPage,
  },
  {
    path: "*",
    component: Page404,
  },
];
